function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React from "react";
import SkeletonElement from "../../SkeletonElement";
import SkeletonGeneralOffer from "../SkeletonCategoryBar/SkeletonGeneralOffer";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function SkeletonDealPage(_ref) {
  var isVisible = _ref.isVisible;
  return /*#__PURE__*/_jsxs("div", {
    className: "h-auto w-full transition-opacity duration-500 ".concat(isVisible ? "opacity-100" : "opacity-0 pointer-events-none"),
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex md:hidden gap-x-6 pt-12 pb-7 animate-pulse",
      children: _toConsumableArray(Array(3).keys()).map(function (n) {
        return /*#__PURE__*/_jsx(SkeletonElement, {
          type: "thumbnail"
        }, n);
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "hidden md:flex lg:hidden gap-x-6 pt-12 pb-7 animate-pulse",
      children: _toConsumableArray(Array(6).keys()).map(function (n) {
        return /*#__PURE__*/_jsx(SkeletonElement, {
          type: "thumbnail"
        }, n);
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "hidden lg:flex gap-x-6 pt-12 pb-7 animate-pulse",
      children: _toConsumableArray(Array(8).keys()).map(function (n) {
        return /*#__PURE__*/_jsx(SkeletonElement, {
          type: "thumbnail"
        }, n);
      })
    }), /*#__PURE__*/_jsx("div", {
      id: "DealsLoader",
      className: "flex w-full gap-4 overflow-x-scroll",
      children: _toConsumableArray(Array(4).keys()).map(function (n) {
        return /*#__PURE__*/_jsx(SkeletonGeneralOffer, {
          shape: "square"
        }, n);
      })
    })]
  });
}
export default SkeletonDealPage;